import angular from 'angular';
import { TurnTypesPanel } from '@alquilatucancha/backoffice-integration';

const moduleName = 'atc-turn-types';

angular.module(moduleName, []).directive('turnTypes', [
    'Backoffice',
    (Backoffice) => ({
        restrict: 'A',
        link: (scope, el) => {
            Backoffice.renderComponent(el[0], TurnTypesPanel, {});

            scope.$on('$destroy', () => {
                Backoffice.unmountComponent?.(el[0]);
            });
        },
    }),
]);

export default moduleName;
